export enum EPhysicalAssesmentsColor {
    Green = 'green',
    Red = 'red',
    Purple = 'purple',
    Yellow = 'yellow',
    Blue = 'blue'
}

export enum ESex {
    MALE = 0,
    FEMALE = 1,
    OTHER = 2
}

export enum EPhysicalActivityLevel {
    SEDENTARY = 0,
    LIGHT = 1,
    MODERATE = 2,
    INTENSE = 3,
    EXTREME = 4
}

export enum EPhysicalActivityLevelLabel {
    SEDENTARY = "Sedentário",
    LIGHT = "Leve",
    MODERATE = "Moderado",
    INTENSE = "Intenso",
    EXTREME = "Extremo"
}

export enum EPhysicalActivityLevelValueMale {
    SEDENTARY = 1.3,
    LIGHT = 1.6,
    MODERATE = 1.7,
    INTENSE = 2.1,
    EXTREME = 2.4
}

export enum EPhysicalActivityLevelValueFemale {
    SEDENTARY = 1.3,
    LIGHT = 1.5,
    MODERATE = 1.6,
    INTENSE = 1.9,
    EXTREME = 2.2
}